import { render, staticRenderFns } from "./SysStatusPub.vue?vue&type=template&id=3c537d34&"
import script from "./SysStatusPub.vue?vue&type=script&lang=js&"
export * from "./SysStatusPub.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/monbi/bbx/assets/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3c537d34')) {
      api.createRecord('3c537d34', component.options)
    } else {
      api.reload('3c537d34', component.options)
    }
    module.hot.accept("./SysStatusPub.vue?vue&type=template&id=3c537d34&", function () {
      api.rerender('3c537d34', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "js/SysStatusPub.vue"
export default component.exports